import { Language } from '../languages';
import { en } from './en';
import { es } from './es';
import { fr } from './fr';
import { de } from './de';
import { it } from './it';
import { da } from './da';

export type { TranslationKeys } from './types';

export const translations: Record<Language, typeof en> = {
  en,
  es,
  fr,
  de,
  it,
  da,
};

export type { Language } from '../languages';
